module.exports = __webpack_public_path__ + "img/CSLHSC-2.f6884917.png";